import { Extension } from '@tiptap/core';

export const CustomParagraphAttributes = Extension.create({
  name: 'customParagraphAttributes',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph'],
        attributes: {
          'data-placeholder': {
            default: null,
            parseHTML: element => element.getAttribute('data-placeholder'),
            renderHTML: attributes => {
              if (!attributes['data-placeholder']) return {};
              return { 'data-placeholder': attributes['data-placeholder'] };
            },
          },
          /*style: {
            default: null,
            parseHTML: element => element.getAttribute('style'),
            renderHTML: attributes => {
              if (!attributes.style) return {};
              return { style: attributes.style };
            },
          },*/
        },
      },
    ];
  },
});